import { Box, Typography } from "@mui/material";
import orderBy from "lodash/orderBy";
import type { FC } from "react";
import { formatDate } from "../../data/dataUtils";

interface Props {
  readonly notes: { date: string; text: string }[];
}

export const LastNotes: FC<Props> = ({ notes }) => {
  const last4Notes = orderBy(notes, (n) => n.date, "desc").slice(0, 4);
  return (
    <Box
      sx={{
        overflow: "hidden",
      }}
    >
      {last4Notes.map((notatka, idx) => (
        <Typography
          variant="body2"
          key={idx}
          data-testid="last-note"
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {formatDate(notatka.date)}: {notatka.text}
        </Typography>
      ))}
    </Box>
  );
};
